// Extracted from GmailPanel.jsx (2026-07-02 audit) — shared constants for the
// email module. Kept as their own file so GmailPanel and future email
// sub-components can import them without duplication.

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// GML-2 (2026-07-12) — the hardcoded ALLOWED_ADMINS array is gone; mailbox
// owner lists come from GET /gmail/allowed-mailboxes.

export const DRIVE_FOLDER_OPTIONS = ["KYC", "Income", "Statements", "Financials", "Property Documents", "Lender Documents", "Signed Documents", "Correspondence", "Settlement"];

// EMAIL-CC-1 (2026-07-25) — every outgoing email from the CRM composer
// defaults to CC'ing the shared loans mailbox, so nothing sent via the
// Gmail or IMAP panels goes unseen by the team. Prefilled into the CC pill
// input when the composer opens (reply/reply-all/forward/new/resend); the
// user can delete the pill for any individual email before sending.
export const DEFAULT_CC = "loans@sgcap.com.au";
